import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import PermissionError from "../components/error/permission-error/PermissionError";
import LoadingOverlay from "../components/loadingoverlay/LoadingOverlay";
import { useFeatures } from "./featureContext";

const ProtectedRoute = ({ allowedFeature, children }) => {
    const { features, loading, fetchError } = useFeatures();
    const { loginWithRedirect } = useAuth0();
    const [redirecting, setRedirecting] = useState(false);

    useEffect(() => {
        if (!fetchError || redirecting) {
            return;
        }

        setRedirecting(true);
        loginWithRedirect();
    }, [fetchError, redirecting, loginWithRedirect]);

    if (loading) {
        return <LoadingOverlay />;
    }

    if (fetchError) {
        return <div>Redirecting to login...</div>;
    }

    const allowedFeatures = Array.isArray(allowedFeature)
        ? allowedFeature
        : [allowedFeature];

    const hasAccess = allowedFeatures.some(feature =>
        features.includes(feature)
    );

    if (!hasAccess) {
        return <PermissionError />;
    }

    return children;
};

export default ProtectedRoute;
